<div *ngIf="isLoading" class="loading-container">
  <mat-spinner diameter="50"></mat-spinner>
  <p>Loading biweekly reports...</p>
</div>

<table mat-table [dataSource]="dataSource" *ngIf="!isLoading">

  <ng-container matColumnDef="reportGeneratedAt">
    <th mat-header-cell *matHeaderCellDef> Date Generated </th>
    <td mat-cell *matCellDef="let element">{{formatDate(element.reportGeneratedAt)}}</td>
  </ng-container>
  
  <ng-container matColumnDef="dateRange">
    <th mat-header-cell *matHeaderCellDef> Biweekly Report Date Range </th>
    <td mat-cell *matCellDef="let element">{{formatDateRange(element.dateRange.startDate, element.dateRange.endDate)}}</td>
  </ng-container>
  
  <ng-container matColumnDef="biweeklyReportUrl">
    <th mat-header-cell *matHeaderCellDef> Biweekly Report </th>
    <td mat-cell *matCellDef="let row" class="flex" style="padding: 10px;">
      <a [href]="row.biweeklyReportUrl" target="_blank" rel="noopener noreferrer" class="memberDashboard1">
        View
      </a>
    </td>
  </ng-container>
  
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<div style="text-align:center;display:flex;" *ngIf="!isLoading">
  <mat-paginator #paginator
                 (page)="pageChangeEvent($event)"
                 [length]="this.totalRecords"
                 [pageSize]="pageSize"
                 [pageIndex]="pageIndex"
                 showFirstLastButton>
  </mat-paginator>
</div>
